<template>
  <div class="dk-custom-page">

    <!-- ── Sidebar de navegação ───────────────────────────── -->
    <aside class="dk-custom-sidebar">

      <!-- Voltar -->
      <button class="dk-sidebar-back" @click="Voltar">
        <feather-icon icon="ArrowLeftIcon" size="14" class="dk-sidebar-back__icon" />
        <span>Voltar ao vídeo</span>
      </button>

      <div class="dk-sidebar-divider" />

      <!-- Nav items -->
      <nav class="dk-sidebar-nav">
        <button
          v-for="item in navItems"
          :key="item.key"
          class="dk-sidebar-item"
          :class="{ 'dk-sidebar-item--active': activeNav === item.key }"
          @click="navigate(item)"
        >
          <span class="dk-sidebar-item__icon-wrap">
            <feather-icon :icon="item.icon" size="16" />
          </span>
          <div class="dk-sidebar-item__text">
            <span class="dk-sidebar-item__label">{{ item.label }}</span>
            <span class="dk-sidebar-item__sub">{{ item.sub }}</span>
          </div>
          <feather-icon icon="ChevronRightIcon" size="14" class="dk-sidebar-item__arrow" />
        </button>
      </nav>
    </aside>

    <!-- ── Área principal: Player ─────────────────────────── -->
    <main class="dk-custom-main">
      <div class="dk-player-shell">

        <!-- Badge de status -->
        <div class="dk-player-header">
          <span class="dk-player-badge">
            <feather-icon icon="VideoIcon" size="12" class="mr-25" />
            Preview do player
          </span>
        </div>

        <!-- Player embed real -->
        <player-preview-iframe
          :vsl-id="vslId"
          :thumb-src="dadosVideo.thumb && dadosVideo.thumb.thumbStart || ''"
          :orientation="dadosVideo.orientation || 'Horizontal'"
        />

        <!-- Dica de ajuda -->
        <div class="dk-player-tip">
          <feather-icon icon="InfoIcon" size="12" class="mr-25" />
          Clique nos itens do menu lateral para personalizar seu player
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue'
import { ControlsService } from '@/services/Controls'
import Detalhes from '../EditarVideo/Detalhes.vue'
import Estilo from './ControleEstilo/Estilo.vue'
import PlayerPreviewIframe from '@/components/player/PlayerPreviewIframe.vue'

export default {
  components: {
    BTabs,
    BTab,
    Detalhes,
    Estilo,
    PlayerPreviewIframe,
  },
  data() {
    return {
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend',
      vslId: this.$route.params.vslId,
      options: {},
      playx: 'true',
      control: [],
      dadosVideo: { thumb: {}, autoPlayer: {}, barra: {}, URL: '' },
      activeNav: null,
      navItems: [
        { key: 'estilo',       label: 'Estilo',                sub: 'Cores, bordas e controles',    icon: 'LayersIcon',      action: 'estilo' },
        { key: 'thumbnails',   label: 'Thumbnails',            sub: 'Imagens de pausa e início',    icon: 'ImageIcon',       action: 'thumbnails' },
        { key: 'autoplay',     label: 'Play Inicial',          sub: 'Configurar autoplay híbrido',  icon: 'PlayCircleIcon',  action: 'AutoPlayHibrido' },
        { key: 'progresso',    label: 'Progresso Inteligente', sub: 'Barra de progresso adaptada',  icon: 'ActivityIcon',    action: 'ProgressoInteligente' },
        { key: 'continuar',    label: 'Continuar Assistindo',  sub: 'Retomar de onde parou',        icon: 'MonitorIcon',     action: 'ContinuarAssistindo' },
        { key: 'botoes',       label: 'Botões de Ação',        sub: 'CTAs, links e temporizadores', icon: 'ZapIcon',         action: 'BotoesAcoes' },
      ],
    }
  },
  computed: {
    getControls() {
      return this.control
    },
  },
  async created() {
    try {
      this.loading = true
      const response = await ControlsService.getControlVSL_Id(this.vslId)
      this.control = response.data
      this.loading = false
    } catch (error) {
      this.errorMessage = error
      this.loading = false
    }
  },
  beforeMount() {
    this.jsonPersonalizado()
  },
  beforeCreate() {
    this.$http.get('/perfil_geral').then(res => {
      this.options = res.data
    })
  },
  methods: {
    navigate(item) {
      this.activeNav = item.key
      this[item.action]()
    },
    jsonPersonalizado() {
      const url = `${this.VUE_APP_HOST_API_BACKEND}/vslsInner/${this.vslId}`
      fetch(url)
        .then(response => response.json())
        .then(data => {
          if (data.status == '1') {
            this.dadosVideo = data.json.find(item => String(item.id) === String(this.vslId))
          } else {
            this.$message({ type: 'danger', message: 'Assinatura não identificada' })
            return this.$router.push('/Videos')
          }
        })
    },
    togglePlay() {
      const player = document.querySelector('.dk-player-wrap')
      const video = player.querySelector('.dk-player-video')
      const playpause = player.querySelector('.dk-player-playpause')
      const pausebg = player.querySelector('.dk-player-thumb-bg--pause')
      const endbg = player.querySelector('.dk-player-thumb-bg--end')
      const iniciar = player.querySelector('.dk-player-autoplay')

      if (video.ended) {
        endbg && endbg.setAttribute('hidden', '')
      }
      if (video.paused) {
        video.play()
        playpause && playpause.setAttribute('hidden', '')
        pausebg && pausebg.setAttribute('hidden', '')
        video.muted = false
      } else if (this.playx == 'true') {
        iniciar && (iniciar.style.visibility = 'hidden')
        video.muted = false
        video.load()
        this.playx = false
      } else {
        video.pause()
        playpause && playpause.removeAttribute('hidden')
        pausebg && pausebg.removeAttribute('hidden')
      }
    },
    avancar() {
      const video = document.querySelector('.dk-player-video')
      if (video) video.currentTime += 10
    },
    retroceder() {
      const video = document.querySelector('.dk-player-video')
      if (video) video.currentTime -= 10
    },
    toggleFullScreen() {
      const player = document.querySelector('.dk-player-wrap')
      if (!document.fullscreenElement) {
        player.requestFullscreen && player.requestFullscreen()
      } else {
        document.exitFullscreen && document.exitFullscreen()
      }
    },
    handleProgress() {
      const video = document.querySelector('.dk-player-video')
      const progressBar = document.querySelector('.dk-player-progress__filled')
      const endbg = document.querySelector('.dk-player-thumb-bg--end')
      const playpause = document.querySelector('.dk-player-playpause')
      if (!video || !progressBar) return
      if (video.ended) {
        endbg && endbg.removeAttribute('hidden')
        playpause && playpause.removeAttribute('hidden')
      }
      const pct = (video.currentTime / (video.duration || 1)) * 100
      progressBar.style.flexBasis = `${Math.min(pct, 100)}%`
    },
    estilo() { this.$router.push({ name: 'estilo' }) },
    thumbnails() { this.$router.push({ name: 'thumbnails' }) },
    AutoPlayHibrido() { this.$router.push({ name: 'AutoPlay-Hibrido' }) },
    ContinuarAssistindo() { this.$router.push({ name: 'Continuar-Assistindo' }) },
    ProgressoInteligente() { this.$router.push({ name: 'Progresso-Inteligente' }) },
    BotoesAcoes() { this.$router.push({ name: 'botoes-acoes', params: { vslId: this.vslId } }) },
    Voltar() { this.$router.push({ name: 'player' }) },
  },
}
</script>

<style lang="scss" scoped>
/* ─── Variáveis ──────────────────────────────────── */
$navy:    #0D3349;
$orange:  #E86A10;
$gold:    #F5B935;
$border:  rgba(255,255,255,0.09);
$bg:      rgba(255,255,255,0.04);
$text:    #e2e8f0;
$muted:   rgba(255,255,255,0.4);
$white:   #ffffff;

/* ─── Layout raiz ────────────────────────────────── */
.dk-custom-page {
  display: flex;
  gap: 24px;
  min-height: calc(100vh - 140px);
  align-items: flex-start;
  padding: 8px 0 40px;
}

/* ─── Sidebar ─────────────────────────────────────── */
.dk-custom-sidebar {
  width: 264px;
  flex-shrink: 0;
  background: rgba(255,255,255,0.05);
  border: 1px solid $border;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.3);
  overflow: hidden;
  position: sticky;
  top: 80px;
}

/* ── Breadcrumb ── */
.dk-breadcrumb {
  display: flex; align-items: center; gap: 4px;
  padding: 12px 16px 0;
  flex-wrap: wrap;
}
.dk-breadcrumb__link {
  font-size: 11px; font-weight: 600; color: $muted;
  text-decoration: none; transition: color 0.15s;
  &:hover { color: $orange; }
}
.dk-breadcrumb__sep { color: $border; flex-shrink: 0; }
.dk-breadcrumb__current { font-size: 11px; font-weight: 700; color: $text; }

/* ── Botão voltar ── */
.dk-sidebar-back {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 16px 20px;
  background: none;
  border: none;
  font-size: 13px;
  font-weight: 500;
  color: $muted;
  cursor: pointer;
  transition: color 0.15s;
  text-align: left;

  &:hover {
    color: $text;
    .dk-sidebar-back__icon { color: $orange; }
  }
}
.dk-sidebar-back__icon {
  color: $muted;
  transition: color 0.15s;
  flex-shrink: 0;
}

.dk-sidebar-divider {
  height: 1px;
  background: rgba(255,255,255,0.07);
  margin: 0;
}

/* ── Nav items ── */
.dk-sidebar-nav {
  padding: 8px 0 12px;
}
.dk-sidebar-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 20px;
  background: none;
  border: none;
  border-left: 3px solid transparent;
  cursor: pointer;
  transition: all 0.15s;
  text-align: left;

  &:hover {
    background: rgba(255,255,255,0.06);
    border-left-color: rgba($orange, 0.4);
    .dk-sidebar-item__label { color: $text; }
    .dk-sidebar-item__icon-wrap { background: rgba($orange, 0.12); color: $orange; }
    .dk-sidebar-item__arrow { opacity: 1; transform: translateX(2px); }
  }

  &--active {
    background: rgba($orange, 0.08);
    border-left-color: $orange;
    .dk-sidebar-item__label { color: #fff; font-weight: 700; }
    .dk-sidebar-item__icon-wrap { background: rgba($orange, 0.15); color: $orange; }
    .dk-sidebar-item__arrow { opacity: 1; }
  }
}
.dk-sidebar-item__icon-wrap {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255,255,255,0.06);
  color: $muted;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.15s;
}
.dk-sidebar-item__text {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.dk-sidebar-item__label {
  font-size: 13px;
  font-weight: 600;
  color: $text;
  transition: color 0.15s;
  line-height: 1.2;
}
.dk-sidebar-item__sub {
  font-size: 11px;
  color: $muted;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dk-sidebar-item__arrow {
  color: $muted;
  opacity: 0;
  flex-shrink: 0;
  transition: all 0.15s;
}

/* ─── Área principal ──────────────────────────────── */
.dk-custom-main {
  flex: 1;
  min-width: 0;
}

.dk-player-shell {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.dk-player-header {
  display: flex;
  align-items: center;
}
.dk-player-badge {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 600;
  color: $muted;
  background: rgba(255,255,255,0.05);
  border: 1px solid $border;
  border-radius: 20px;
  padding: 4px 12px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

/* ─── Player container ────────────────────────────── */
.dk-player-wrap {
  position: relative;
  width: 100%;
  background: #0a1520;
  border-radius: 14px;
  overflow: hidden;
  box-shadow:
    0 4px 6px rgba(0,0,0,0.07),
    0 12px 40px rgba($navy, 0.18),
    inset 0 0 0 1px rgba(255,255,255,0.04);
}

.dk-player-video {
  width: 100%;
  height: 440px;
  display: block;
  object-fit: contain;
  background: #0a1520;
}

/* ─── Autoplay overlay ────────────────────────────── */
.dk-player-autoplay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(10, 21, 32, 0.6);
  backdrop-filter: blur(2px);
  cursor: pointer;
  z-index: 10;
}
.dk-autoplay-card {
  background: rgba(255,255,255,0.07);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 20px;
  padding: 28px 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  backdrop-filter: blur(12px);
  min-width: 260px;
  transition: transform 0.2s, background 0.2s;

  &:hover {
    background: rgba(255,255,255,0.12);
    transform: scale(1.02);
  }
}
.dk-autoplay-icon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: $orange;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  margin-bottom: 4px;
  box-shadow: 0 4px 20px rgba($orange, 0.45);
}
.dk-autoplay-top {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  margin: 0;
  text-align: center;
}
.dk-autoplay-bottom {
  font-size: 12px;
  font-weight: 500;
  color: rgba(255,255,255,0.6);
  margin: 0;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

/* ── Ondas de áudio ── */
.dk-autoplay-waves {
  display: flex;
  align-items: center;
  gap: 3px;
  height: 32px;
}
.dk-wave-bar {
  display: block;
  width: 3px;
  background: rgba(255,255,255,0.5);
  border-radius: 3px;
  animation: dk-wave 1.2s ease-in-out infinite alternate;
  min-height: 4px;
}
@keyframes dk-wave {
  0%   { height: 4px;  background: rgba(255,255,255,0.3); }
  50%  { height: 24px; background: $orange; }
  100% { height: 8px;  background: rgba(255,255,255,0.5); }
}
.dk-wave-bar:nth-child(1)  { animation-delay: 0s; }
.dk-wave-bar:nth-child(2)  { animation-delay: 0.08s; }
.dk-wave-bar:nth-child(3)  { animation-delay: 0.16s; }
.dk-wave-bar:nth-child(4)  { animation-delay: 0.24s; }
.dk-wave-bar:nth-child(5)  { animation-delay: 0.32s; }
.dk-wave-bar:nth-child(6)  { animation-delay: 0.40s; }
.dk-wave-bar:nth-child(7)  { animation-delay: 0.32s; }
.dk-wave-bar:nth-child(8)  { animation-delay: 0.24s; }
.dk-wave-bar:nth-child(9)  { animation-delay: 0.16s; }
.dk-wave-bar:nth-child(10) { animation-delay: 0.08s; }
.dk-wave-bar:nth-child(11) { animation-delay: 0.04s; }
.dk-wave-bar:nth-child(12) { animation-delay: 0s; }

/* ─── Thumbnails bg ───────────────────────────────── */
.dk-player-thumb-bg {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: absolute;
  inset: 0;
  z-index: 5;
  border-radius: 14px;
}

/* ─── Controles do player ─────────────────────────── */
.dk-player-controls {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 20;
  transform: translateY(100%);
  transition: transform 0.25s;
  background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, transparent 100%);
  border-radius: 0 0 14px 14px;
  padding: 8px 4px 4px;
}
.dk-player-wrap:hover .dk-player-controls {
  transform: translateY(0);
}

.dk-player-progress {
  width: 100%;
  background: rgba(255,255,255,0.2);
  cursor: pointer;
  display: flex;
  margin-bottom: 4px;
}
.dk-player-progress__filled {
  height: 100%;
  flex: 0;
  flex-basis: 0%;
  transition: flex-basis 0.1s linear;
}

.dk-player-controls__row {
  display: flex;
  align-items: center;
  padding: 0 8px;
}
.dk-ctrl-spacer { flex: 1; }
.dk-ctrl-btn {
  background: none;
  border: none;
  color: #fff;
  padding: 8px 10px;
  cursor: pointer;
  opacity: 0.85;
  transition: opacity 0.15s;
  display: flex;
  align-items: center;
  &:hover { opacity: 1; }
}

/* ─── Botão playpause (overlay central) ───────────── */
.dk-player-playpause {
  border-radius: 50px;
  background-image: url(./img/play.svg);
  background-repeat: no-repeat;
  width: 80px;
  height: 80px;
  position: absolute;
  inset: 0;
  margin: auto;
  background-size: contain;
  background-position: center;
  cursor: pointer;
  z-index: 10;
  opacity: 1;
  transition: opacity 0.3s;

  &[hidden] { opacity: 0; pointer-events: none; }
}

/* ─── Dica de ajuda ───────────────────────────────── */
.dk-player-tip {
  display: flex;
  align-items: center;
  font-size: 11.5px;
  color: $muted;
  padding: 0 4px;
}
</style>
